// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';

// Redux Actions
import {logout} from '../../actions/auth-actions';

// Components
import Button from './button';

function Logout({className, logout, buttonType}) {
    const handleClick = (event) => {
        event && event.preventDefault && event.preventDefault();

        logout();
    };
    const getClass = classnames(
        {
            logout: true,
        },
        className
    );

    return (
        <Button className={getClass} type={buttonType} onClick={handleClick}>
            Logout
        </Button>
    );
}

Logout.propTypes = {
    buttonType: PropTypes.string,
    className: PropTypes.string,
    logout: PropTypes.func.isRequired,
};

const mapDispatchToProps = {logout};

export default connect(undefined, mapDispatchToProps)(Logout);
